import store from '@/store'
import * as mutationTypes from '@/store/mutation-types'
let Socket = ''
let wsUrl = ''

/**
 * 建立 websocket 连接
 * @param {string} url ws 地址
 */
export const createSocket = function (url, isReconnecting) {
  if (!Socket) {
    // 如果 webSocket 对象不存在
    wsUrl = url
    console.log('创建websocket对象')
    Socket = new WebSocket(url)
    Socket.onopen = onopenWS
    Socket.onmessage = onmessageWS
    Socket.onerror = onerrorWS
    Socket.onclose = oncloseWS
    window.Socket = Socket

    // if (isReconnecting) {
    //   // 断开重连时，重新发送一些 action
    //   const tradingPair = store.state.transaction.tradingPair
    //     .toLowerCase()
    //     .replace('/', '_')

    //   /* eslint-disable */
    //   sendWSPush({ channel: 'public', language: 'zh' })
    //   sendWSPush({ channel: tradingPair, language: 'zh' })

    //   EventBus.$emit('getCoinLoading', true)
    //   const { type, from, to } = getResolution(
    //     store.state.tradingview.resolution
    //   )
    //   sendWSPush({
    //     channel: 'kline',
    //     market: tradingPair,
    //     type,
    //     subType: 'unsub'
    //   })
    //   sendWSPush({
    //     channel: 'req_kline',
    //     market: tradingPair,
    //     type,
    //     from,
    //     to
    //   })
    //   sendWSPush({
    //     channel: 'kline',
    //     market: tradingPair,
    //     type,
    //     subType: 'sub'
    //   })
    //   /* eslint-enalbe */
    // }
  } else {
    console.log('websocket已连接')
  }
}

function onopenWS(params) {
  console.log('websocket连接成功：', params)
}

// 盘口
const trustHandler = (data) => {
  store.commit('contract/SET_PLATE_DATA', data)
}
// 行情
const quotelHandler = (data) => {
  store.commit('contract/SET_QUOTE_DATA', data)
}
//  增量K线
const kLineHandler = (data) => {
  store.commit('contract/SET_KLINE_DATA', data)
}

// WS 数据接收统一处理
function onmessageWS({ data }) {
  if (data) {
    data = JSON.parse(data)
    if ('symbol' in data) {
      kLineHandler(data)
    } else if ('asks' in data || 'bids' in data) {
      trustHandler(data)
    } else {
      quotelHandler(data)
    }
  }
}

// 连接失败重连
function onerrorWS(params) {
  console.log('连接失败重连', '当前连接状态：', Socket)
  Socket.close()
  // clearInterval(setIntervalWesocketPush)
  // console.log('连接失败重连', '当前连接状态：', Socket.readyState)
  if (Socket.readyState !== 3) {
    Socket = null
    setTimeout(() => {
      createSocket(wsUrl, 'isReconnecting')
    }, 5 * 1000)
  }
}

// 连接关闭重连
function oncloseWS() {
  // clearInterval(setIntervalWesocketPush)
  console.log('连接关闭重连', '当前连接状态：', Socket)
  if (Socket.readyState !== 2) {
    Socket = null
    setTimeout(() => {
      createSocket(wsUrl, 'isReconnecting')
    }, 5 * 1000)
  }
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = function (message) {
  console.log(message, '发送数据')
  if (Socket.readyState === 0) {
    connecting(message)
  } else if (Socket.readyState === 1) {
    Socket.send(JSON.stringify(message))
  } else if (Socket.readyState === 3) {
    createSocket(wsUrl, 'isReconnecting')
  }
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = function (message) {
  setTimeout(function () {
    if (Socket.readyState === 0) {
      connecting(message)
    } else if (Socket.readyState === 1) {
      Socket.send(JSON.stringify(message))
    }
  }, 1000)
}
